import React from "react";
import styles from "./index.module.css";
import { BackArrow, PersonalIcon, CollectiveIcon } from "../../icons";
import Wrapper from "../../components/UI/wrapper";
import { Link } from "react-router-dom";
const Registration = () => {
  return (
    <Wrapper>
      {/* <Link to={"/"} className={styles["go-back"]}>
        <BackArrow />
        <p>Geri qayıt</p>
      </Link> */}
      <div className={styles["fl"]}>
        {/* <div className={styles["container"]}>
          <Link to={"/personal-registration"}>
            <PersonalIcon />
            <p>Fərdi</p>
          </Link>
          <Link to={"/collective-registration"}>
            <CollectiveIcon />
            <p>Kollektiv</p>
          </Link>
        </div> */}
        <h2 className={styles["announcement"]}>
          Qeydiyyat bitmişdir
        </h2>
        <Link to={"/"} className={styles["return"]}>
          Ana səhifəyə geri dön
        </Link>

      </div>
    </Wrapper>
  );
};

export default Registration;
